import { getChubbLegacyConfig, isChubbLegacyEnabled } from '@/config/chubbLegacy'
import {
  requestChubbQuoteAt,
  type ChubbProviderSession,
  type ChubbQuotePayload,
  type ChubbQuoteSuccess,
} from '@/services/chubbApi'
import { mapChubbQuoteToCotizaResponse } from '@/services/chubbLegacy/mapQuote'
import type { CotizaTodasResponse } from '@/types/quote.types'

export { CHUBB_ID_CIA, mapChubbQuoteToCotizaResponse } from '@/services/chubbLegacy/mapQuote'
export { buildLegacyChubbPayload } from '@/services/chubbLegacy/buildPayload'
export { hasAuthenticDemographics, isAuthenticGender } from '@/services/chubbLegacy/demographics'

/** Amplia + Contado only for the widget Chubb API (v1). */
export function isChubbPlanPaymentAllowed(formaPago: string, paquete: string): boolean {
  return formaPago === 'C' && paquete === '1'
}

export async function fetchLegacyChubbQuote(
  payload: ChubbQuotePayload,
): Promise<{ quote: ChubbQuoteSuccess; mapped: CotizaTodasResponse; session: ChubbProviderSession }> {
  if (!isChubbLegacyEnabled()) {
    throw new Error('Chubb no está habilitado en este host.')
  }
  const { apiBaseUrl } = getChubbLegacyConfig()
  const quote = await requestChubbQuoteAt(apiBaseUrl, payload)
  return {
    quote,
    mapped: mapChubbQuoteToCotizaResponse(quote),
    session: quote.providerSession,
  }
}
